import { InjectionToken } from '@angular/core';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils';
export const AJSGetCKICachedInformationServiceToken = new InjectionToken<any>('GetCKICachedInformationService');
export const AJSGetCKICachedInformationServiceProvider = upgradeAJSServiceProvider( 'GetCKICachedInformationService', AJSGetCKICachedInformationServiceToken );

export interface AJSGetCKICachedInformationServiceType extends GetCKICachedInformationService { }
